<div #flatpickrEl class="ag-input-wrapper custom-date-filter" role="presentation">
    <input type="text" #eInput data-input style="width: 100%;" [placeholder]="dateFormat"/>
    <a class='input-button' title='clear' data-clear>
        <motif-icon class='fa fa-times' [src]="'/assets/images/clear.svg'"></motif-icon>
    </a>
</div>